import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getNotifications, updateNotification } from '../../api/notificationAPI';
import { log, getStackTrace } from "@src/Log.init";
  
export const retrieveNotifications = createAsyncThunk(
    'notification/retrieveNotifications',
    async (arg, { getState, dispatch }) => {
        const response = await getNotifications(getState().session.sessionToken);
        await dispatch(setNotifications(response));
        return response;
})
  
export const readNotification = createAsyncThunk(
    'notification/readNotification',
    async (arg, { getState, dispatch }) => {
        const response = await updateNotification(getState().session.sessionToken, arg);
        await dispatch(markNotificationAsRead(response));
        return response;
    })
      
export const notificationSlice = createSlice({
  name: 'notification',
  initialState: {
    notifications: [],
  },
  reducers: {
    setNotifications: (state, action) => {
        state.notifications = action.payload;
    },
    markNotificationAsRead: (state, action) => {
      var foundIndex = state.notifications.findIndex(notification => notification._id === action.payload.notification);
      if (foundIndex >= 0) {
        const update = {...state.notifications[foundIndex], read: true}
        state.notifications[foundIndex] = update;
      }
    },
},
  extraReducers: {
    [retrieveNotifications.pending]: (state, action) => {
      log.debug({message_type: "Notification", message: "Retrieving notifications"});
    },
    [retrieveNotifications.fulfilled]: (state, action) => {
      log.info({message_type: "Notification", message: "Notifications retrieval successful"});
    },
    [retrieveNotifications.rejected]: (state, action) => {
      log.error({message_type: "SystemError", message: "Notifications retrieval failed", meta_data: getStackTrace()});
    },
    [readNotification.pending]: (state, action) => {
      log.debug({message_type: "Notification", message: "Updating notification"});
    },
    [readNotification.fulfilled]: (state, action) => {
      log.info({message_type: "Notification", message: "Notification update successful"});
    },
    [readNotification.rejected]: (state, action) => {
      log.error({message_type: "SystemError", message: "Notification update failed", meta_data: getStackTrace()});
    },
  },
});

export const { setNotifications,
               markNotificationAsRead,
             } = notificationSlice.actions;
         
export const selectNotifications = state => state.notification.notifications;

export default notificationSlice.reducer;
